import React, { useState, useEffect, useRef } from 'react';
import apinode from '../../services/apinode';
import './TVLiberacaoComponent.css';

// ── Utilitários ──────────────────────────────────────────────
const formatarHora = (iso) => {
  if (!iso) return '--:--';
  const d = new Date(iso);
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};

const formatarTempo = (minutos) => {
  const m = parseInt(minutos || 0);
  if (m <= 0) return '0m';
  if (m >= 60) return `${Math.floor(m / 60)}h ${m % 60}m`;
  return `${m}m`;
};

const getCorTempo = (minutos) => {
  const m = parseInt(minutos || 0);
  if (m <= 10) return '#51cf66';
  if (m <= 25) return '#ffa500';
  return '#ff6b6b';
};

const calcUPH = (totalConferencias, minTrabalhado) => {
  const total = parseInt(totalConferencias || 0);
  const min   = parseFloat(minTrabalhado  || 0);
  if (min < 15 || total < 2) return null;
  return (total / (min / 60)).toFixed(1);
};

const calcParticipacao = (confTotal, totalGeral) => {
  if (!totalGeral || totalGeral === 0) return 0;
  return ((confTotal / totalGeral) * 100).toFixed(1);
};

const formatarHorario = (date) => {
  if (!date) return '--:--';
  return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};

const corUrgencia = (minutos) => {
  if (minutos === null || minutos === undefined) return '#64748b';
  if (minutos > 60) return '#51cf66';
  if (minutos > 30) return '#ffa500';
  return '#ff6b6b';
};

// ── Card de Conta ─────────────────────────────────────────────
const ContaCard = ({ conta, uphGlobal }) => {
  const { nome, pendentes, atendidos, total, pctAtendido, coleta, minutosCutoff, temColeta } = conta;

  const pctPendente = total > 0 ? (100 - parseFloat(pctAtendido)).toFixed(1) : '0.0';
  const corCutoff   = corUrgencia(minutosCutoff);
  const corPendente = parseFloat(pctPendente) <= 20 ? '#51cf66'
                    : parseFloat(pctPendente) <= 50 ? '#ffa500'
                    : '#ff6b6b';

  let previsaoConta = null;
  if (uphGlobal && uphGlobal > 0 && pendentes > 0) {
    const minRest = Math.round((pendentes / uphGlobal) * 60);
    const dt = new Date();
    dt.setMinutes(dt.getMinutes() + minRest);
    previsaoConta = { minutos: minRest, horario: dt };
  }

  const vaiEstourar = previsaoConta && minutosCutoff !== null && minutosCutoff > 0 && previsaoConta.minutos > minutosCutoff;
  const emAlerta    = temColeta && minutosCutoff !== null && minutosCutoff <= 5 && pendentes > 0;

  return (
    <div style={{
      backgroundColor: emAlerta ? 'rgba(255,107,107,0.06)' : '#0f172a',
      border: `1px solid ${emAlerta ? '#ff6b6b66' : vaiEstourar ? '#ff6b6b44' : '#1e293b'}`,
      borderTop: `3px solid ${emAlerta ? '#ff6b6b' : vaiEstourar ? '#ff6b6b' : corCutoff}`,
      borderRadius: '10px', padding: '1rem',
      display: 'flex', flexDirection: 'column', gap: '0.6rem',
      flex: '1 1 0', minWidth: 0, boxSizing: 'border-box',
      position: 'relative',
      ...(emAlerta ? { animation: 'pulse-card 2s ease-in-out infinite' } : {}),
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: '1.1rem', fontWeight: 700, color: '#f1f5f9', letterSpacing: '0.5px' }}>{nome}</span>
        {emAlerta && (
          <span style={{ fontSize: '0.6rem', color: '#ff6b6b', fontWeight: 700, backgroundColor: 'rgba(255,107,107,0.2)', padding: '2px 7px', borderRadius: '99px', border: '1px solid #ff6b6b55', animation: 'pulse-badge 1s ease-in-out infinite' }}>
            ⚠ CORTE
          </span>
        )}
        {!emAlerta && vaiEstourar && (
          <span style={{ fontSize: '0.6rem', color: '#ff6b6b', fontWeight: 700, backgroundColor: 'rgba(255,107,107,0.15)', padding: '2px 6px', borderRadius: '99px' }}>
            🚨 RISCO
          </span>
        )}
        {!temColeta && (
          <span style={{ fontSize: '0.6rem', color: '#64748b', backgroundColor: '#1e293b', padding: '2px 6px', borderRadius: '99px' }}>
            sem coleta
          </span>
        )}
      </div>

      <div style={{ display: 'flex', gap: '0.5rem' }}>
        {[
          { label: 'Pendentes', valor: pendentes, cor: corPendente },
          { label: 'Atendidos', valor: atendidos, cor: '#51cf66'  },
          { label: 'Total',     valor: total,     cor: '#94a3b8'  },
        ].map(({ label, valor, cor }) => (
          <div key={label} style={{ flex: 1, backgroundColor: '#1e293b', borderRadius: '8px', padding: '0.5rem', textAlign: 'center' }}>
            <div style={{ fontSize: '1.4rem', fontWeight: 700, color: cor, lineHeight: 1 }}>{valor}</div>
            <div style={{ fontSize: '0.6rem', color: '#64748b', marginTop: '0.2rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</div>
          </div>
        ))}
      </div>

      {total > 0 && (
        <div>
          <div style={{ width: '100%', height: '8px', backgroundColor: '#1e293b', borderRadius: '99px', overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${pctAtendido}%`, background: 'linear-gradient(90deg, #16a34a, #51cf66)', borderRadius: '99px', transition: 'width 1s ease', boxShadow: '0 0 6px #51cf6655' }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.25rem' }}>
            <span style={{ fontSize: '0.6rem', color: '#51cf66', fontWeight: 600 }}>✓ {pctAtendido}%</span>
            <span style={{ fontSize: '0.6rem', color: corPendente, fontWeight: 600 }}>⏳ {pctPendente}%</span>
          </div>
        </div>
      )}

      {previsaoConta && pendentes > 0 && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#1e293b', borderRadius: '8px', padding: '0.4rem 0.6rem' }}>
          <span style={{ fontSize: '0.62rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.4px' }}>🎯 Previsão</span>
          <span style={{ fontSize: '0.85rem', fontWeight: 700, color: corUrgencia(previsaoConta.minutos) }}>
            {formatarHorario(previsaoConta.horario)}
            <span style={{ fontSize: '0.6rem', color: '#64748b', fontWeight: 400, marginLeft: '4px' }}>(~{formatarTempo(previsaoConta.minutos)})</span>
          </span>
        </div>
      )}

      {pendentes === 0 && (
        <div style={{ textAlign: 'center', padding: '0.25rem 0' }}>
          <span style={{ fontSize: '0.8rem', color: '#51cf66', fontWeight: 700 }}>✅ Fila zerada!</span>
        </div>
      )}

      {temColeta && coleta && (
        <div style={{ borderTop: '1px solid #1e293b', paddingTop: '0.5rem', display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '0.62rem', color: '#64748b' }}>🚚 Coleta</span>
            <span style={{ fontSize: '0.72rem', fontWeight: 600, color: '#94a3b8' }}>{coleta.from} – {coleta.to}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '0.62rem', color: '#64748b' }}>🔔 Corte</span>
            <span style={{ fontSize: '0.85rem', fontWeight: 700, color: corCutoff }}>
              {coleta.cutoff}
              {minutosCutoff !== null && minutosCutoff > 0 && (
                <span style={{ fontSize: '0.6rem', color: '#64748b', fontWeight: 400, marginLeft: '4px' }}>({formatarTempo(minutosCutoff)})</span>
              )}
              {minutosCutoff !== null && minutosCutoff <= 0 && (
                <span style={{ fontSize: '0.6rem', color: '#ff6b6b', fontWeight: 600, marginLeft: '4px' }}>passou!</span>
              )}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

// ── Componente Principal ──────────────────────────────────────
const TVLiberacaoComponent = ({ conta }) => {
  const [dados, setDados]                   = useState(null);
  const [loading, setLoading]               = useState(true);
  const [erro, setErro]                     = useState(null);
  const [horaAtual, setHoraAtual]           = useState(new Date());
  const [ultimaAtualizacao, setUltimaAtual] = useState(null);

  const intervalRef = useRef(null);
  const relogioRef  = useRef(null);

  useEffect(() => {
    relogioRef.current = setInterval(() => setHoraAtual(new Date()), 1000);
    return () => clearInterval(relogioRef.current);
  }, []);

  useEffect(() => {
    fetchDados();
    intervalRef.current = setInterval(fetchDados, 60000);
    return () => clearInterval(intervalRef.current);
  }, [conta]);

  const fetchDados = async () => {
    try {
      const idConta = conta || localStorage.idconta;
      const response = await apinode.get(`tv-liberacao/${idConta}`);
      if (response.status !== 200) throw new Error('Erro na API');
      setDados(response.data);
      setUltimaAtual(new Date());
      setErro(null);
    } catch (err) {
      console.error('Erro TV:', err);
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  };

  const { contasBreakdown = [] } = dados || {};

  if (loading) return (
    <div className="tv-loading">
      <div className="tv-loading-spinner" />
      <p>Carregando dashboard...</p>
    </div>
  );

  if (erro) return (
    <div className="tv-erro">
      <span>⚠</span>
      <p>Erro ao carregar dados: {erro}</p>
      <button onClick={fetchDados}>Tentar novamente</button>
    </div>
  );

  const {
    ultimoPedido, conferindoAgora, aguardandoConferencia,
    aguardandoFaturamento, atendidosHoje, tempoSemPedido, metricas,
  } = dados || {};

  const totalGeralConferencias = (metricas || []).reduce((sum, c) => sum + (c.total_conferencias || 0), 0);

  const atendidos   = atendidosHoje || 0;
  const restante    = aguardandoConferencia || 0;
  const totalGeral  = atendidos + restante;
  const pctAtendido = totalGeral > 0 ? ((atendidos / totalGeral) * 100).toFixed(1) : 0;
  const pctRestante = totalGeral > 0 ? ((restante / totalGeral) * 100).toFixed(1) : 0;
  const corRestante = pctRestante <= 20 ? '#51cf66' : pctRestante <= 50 ? '#ffa500' : '#ff6b6b';

  const conferentesComAlerta = (tempoSemPedido || []).filter(c => {
    const estaAtivo = (conferindoAgora || []).some(a => a.conferente === c.conferente);
    return !estaAtivo && parseInt(c.minutos_sem_pedido || 0) > 20;
  });

  const uphGlobal = (() => {
    const ativos = (metricas || []).filter(c =>
      (conferindoAgora || []).some(a => a.conferente === c.conferente)
    );
    const base = ativos.length > 0 ? ativos : (metricas || []);

    const uphValidos = base
      .map(c => {
        const min   = parseFloat(c.tempo_trabalhado_minutos || 0);
        const total = parseInt(c.total_conferencias || 0);
        if (min < 15 || total < 2) return null;
        return total / (min / 60);
      })
      .filter(Boolean);

    return uphValidos.length > 0
      ? uphValidos.reduce((s, v) => s + v, 0)
      : null;
  })();

  const previsaoGlobal = (() => {
    if (!uphGlobal || restante <= 0) return null;
    const minRest = Math.round((restante / uphGlobal) * 60);
    const dt = new Date();
    dt.setMinutes(dt.getMinutes() + minRest);
    return { minutosRestantes: minRest, previsao: dt, uphTotal: uphGlobal.toFixed(1) };
  })();

  const cutoffMaisProximo = (contasBreakdown || [])
    .filter(c => c.temColeta && c.minutosCutoff !== null && c.minutosCutoff > 0)
    .sort((a, b) => a.minutosCutoff - b.minutosCutoff)[0] || null;

  const corPrevisao       = previsaoGlobal    ? corUrgencia(previsaoGlobal.minutosRestantes) : '#64748b';
  const corCutoffMin      = cutoffMaisProximo ? corUrgencia(cutoffMaisProximo.minutosCutoff) : '#64748b';
  const vaiEstourarGlobal = previsaoGlobal && cutoffMaisProximo
    && previsaoGlobal.minutosRestantes > cutoffMaisProximo.minutosCutoff;

  const statusCardStyle = {
    flex: '1 1 0', minWidth: 0,
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'flex-start',
    padding: '1rem 0.75rem', boxSizing: 'border-box',
  };

  return (
    <>
      <style>{`
        @keyframes pulse-badge { 0%, 100% { opacity: 1; } 50% { opacity: 0.6; } }
        @keyframes pulse-card  { 0%, 100% { box-shadow: 0 0 0 0 rgba(255,107,107,0); } 50% { box-shadow: 0 0 18px 4px rgba(255,107,107,0.18); } }
        @keyframes pulse-alert { 0%, 100% { box-shadow: 0 0 0 0 rgba(255,107,107,0.4); } 50% { box-shadow: 0 0 0 10px rgba(255,107,107,0); } }
        .tv-alerta-estouro { animation: pulse-alert 2s ease-in-out infinite; }
      `}</style>

      <div className="tv-container">

        {/* ── Cabeçalho ── */}
        <header className="tv-header">
          <div className="tv-header-left">
            <div className="tv-pulse-dot" />
            <span className="tv-header-title">Liberação — Tempo Real</span>
          </div>
          <div className="tv-header-center">
            <span className="tv-relogio">
              {horaAtual.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
            </span>
            <span className="tv-data">
              {horaAtual.toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long' })}
            </span>
          </div>
          <div className="tv-header-right">
            {ultimaAtualizacao && (
              <span className="tv-ultima-atualizacao">↻ {formatarHora(ultimaAtualizacao)}</span>
            )}
          </div>
        </header>

        {/* ── Previsão + Cutoff ── */}
        <section style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'stretch', gap: '0.75rem', width: '100%', boxSizing: 'border-box' }}>
          <div className="tv-status-card" style={{ flex: 1, minWidth: 0, padding: '1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '0.25rem', borderTop: `3px solid ${corPrevisao}`, boxSizing: 'border-box' }}>
            <span style={{ fontSize: '0.65rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.6px', fontWeight: 700 }}>🎯 Previsão Global</span>
            {previsaoGlobal ? (
              <>
                <span style={{ fontSize: '1.75rem', fontWeight: 700, color: corPrevisao, lineHeight: 1.1 }}>{formatarHorario(previsaoGlobal.previsao)}</span>
                <span style={{ fontSize: '0.72rem', color: '#94a3b8' }}>em ~{formatarTempo(previsaoGlobal.minutosRestantes)}</span>
                <span style={{ fontSize: '0.62rem', color: '#475569', marginTop: '0.1rem' }}>capacidade: {previsaoGlobal.uphTotal} ped/h</span>
              </>
            ) : restante === 0 ? (
              <span style={{ fontSize: '1rem', color: '#51cf66', fontWeight: 700 }}>✅ Fila zerada!</span>
            ) : (
              <span style={{ fontSize: '0.8rem', color: '#475569', textAlign: 'center' }}>Sem dados suficientes<br />para previsão</span>
            )}
          </div>

          <div className="tv-status-card" style={{ flex: 1, minWidth: 0, padding: '1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '0.25rem', borderTop: `3px solid ${corCutoffMin}`, boxSizing: 'border-box' }}>
            <span style={{ fontSize: '0.65rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.6px', fontWeight: 700 }}>🔔 Próximo Corte</span>
            {cutoffMaisProximo ? (
              <>
                <span style={{ fontSize: '0.65rem', color: '#475569' }}>{cutoffMaisProximo.nome}</span>
                <span style={{ fontSize: '1.75rem', fontWeight: 700, color: corCutoffMin, lineHeight: 1.1 }}>{cutoffMaisProximo.coleta?.cutoff}</span>
                {cutoffMaisProximo.minutosCutoff > 0
                  ? <span style={{ fontSize: '0.72rem', color: '#94a3b8' }}>faltam ~{formatarTempo(cutoffMaisProximo.minutosCutoff)}</span>
                  : <span style={{ fontSize: '0.72rem', color: '#ff6b6b', fontWeight: 700 }}>⚠ Cutoff passou!</span>
                }
              </>
            ) : (
              <span style={{ fontSize: '0.85rem', color: '#475569' }}>Sem coleta hoje</span>
            )}
          </div>

          {vaiEstourarGlobal && (
            <div className="tv-status-card tv-alerta-estouro" style={{ flex: 1, minWidth: 0, padding: '1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '0.25rem', borderTop: '3px solid #ff6b6b', backgroundColor: 'rgba(255,107,107,0.07)', boxSizing: 'border-box' }}>
              <span style={{ fontSize: '1.5rem', lineHeight: 1 }}>🚨</span>
              <span style={{ fontSize: '0.72rem', color: '#ff6b6b', fontWeight: 700, textAlign: 'center', lineHeight: 1.5 }}>Fila não termina<br />antes do cutoff!</span>
              <span style={{ fontSize: '0.62rem', color: '#94a3b8', textAlign: 'center', marginTop: '0.15rem' }}>
                +{formatarTempo(previsaoGlobal.minutosRestantes - cutoffMaisProximo.minutosCutoff)} de atraso
              </span>
            </div>
          )}
        </section>

        {/* ── Contadores Globais ── */}
        <section className="tv-status-row" style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'stretch', gap: '0.75rem', width: '100%', boxSizing: 'border-box' }}>

          <div className="tv-status-card tv-status-card--ativo" style={statusCardStyle}>
            <div className="tv-status-icon">⚡</div>
            <div className="tv-status-label">Conferindo Agora</div>
            <div className="tv-status-numero">{(conferindoAgora || []).length}</div>
            <div className="tv-status-nomes">
              {(conferindoAgora || []).length === 0
                ? <span className="tv-vazio">Nenhum ativo</span>
                : (conferindoAgora || []).map((c, i) => (
                    <span key={i} className="tv-nome-pill tv-nome-pill--ativo">
                      {c.conferente?.split(' ')[0]}
                      <small>{formatarHora(c.data_conferencia)}</small>
                    </span>
                  ))
              }
            </div>
          </div>

          <div className="tv-status-card tv-status-card--aguardando" style={statusCardStyle}>
            <div className="tv-status-icon">📋</div>
            <div className="tv-status-label">Ag. Conferência</div>
            <div className="tv-status-numero">{aguardandoConferencia || 0}</div>
            <div className="tv-status-sub">pedidos na fila</div>
          </div>

          <div className="tv-status-card tv-status-card--faturamento" style={statusCardStyle}>
            <div className="tv-status-icon">🧾</div>
            <div className="tv-status-label">Ag. Faturamento</div>
            <div className="tv-status-numero">{aguardandoFaturamento || 0}</div>
            <div className="tv-status-sub">conferidos / pendente NF</div>
          </div>

          <div className="tv-status-card tv-status-card--atendidos" style={statusCardStyle}>
            <div className="tv-status-icon">📦</div>
            <div className="tv-status-label">Atendidos Hoje</div>
            <div className="tv-status-numero">{atendidosHoje || 0}</div>
            <div className="tv-status-sub">pedidos conferidos</div>
          </div>

          <div className="tv-status-card" style={{ ...statusCardStyle, borderTop: `3px solid ${corRestante}`, position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', bottom: 0, left: 0, height: '3px', width: '100%', backgroundColor: '#1e293b' }}>
              <div style={{ height: '100%', width: `${pctAtendido}%`, backgroundColor: '#51cf66', transition: 'width 0.8s ease', boxShadow: '0 0 6px #51cf6688' }} />
            </div>
            <div className="tv-status-icon">⏳</div>
            <div className="tv-status-label">Restante p/ Conferir</div>
            <div className="tv-status-numero" style={{ color: corRestante }}>{restante}</div>
            <div style={{ marginTop: '0.35rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.2rem' }}>
              <span style={{ fontSize: '1.15rem', fontWeight: 700, color: corRestante, lineHeight: 1 }}>{pctRestante}%</span>
              <span style={{ fontSize: '0.62rem', color: '#64748b', textAlign: 'center', lineHeight: 1.4 }}>
                da fila total<br />
                <span style={{ color: '#51cf66', fontWeight: 600 }}>{pctAtendido}% conferido</span>
              </span>
            </div>
          </div>

          <div className="tv-status-card tv-status-card--ultimo" style={statusCardStyle}>
            <div className="tv-status-icon">✅</div>
            <div className="tv-status-label">Último Conferido</div>
            {ultimoPedido ? (
              <>
                <div className="tv-ultimo-conferente">{ultimoPedido.conferente?.split(' ')[0]}</div>
                <div className="tv-ultimo-detalhe">
                  <span className="tv-ultimo-pedido">Ped. {ultimoPedido.pedido}</span>
                  <span className="tv-ultimo-hora">{formatarHora(ultimoPedido.data_conferencia)}</span>
                </div>
                {ultimoPedido.cliente && <div className="tv-ultimo-cliente">{ultimoPedido.cliente}</div>}
              </>
            ) : (
              <div className="tv-vazio">Sem registros hoje</div>
            )}
          </div>
        </section>

        {/* ── Cards por Conta ── */}
        {(contasBreakdown || []).length > 0 && (
          <section style={{ width: '100%', boxSizing: 'border-box' }}>
            <div className="tv-section-title" style={{ marginBottom: '0.75rem' }}>
              Situação por Conta
              <span style={{ marginLeft: '0.75rem', fontSize: '0.8rem', fontWeight: 400, color: '#94a3b8' }}>
                — pedidos pendentes, coleta e corte de cada ML
              </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '0.75rem', width: '100%', alignItems: 'stretch' }}>
              {(contasBreakdown || []).map((c) => (
                <ContaCard key={c.id} conta={c} uphGlobal={uphGlobal} />
              ))}
            </div>
          </section>
        )}

        {/* ── Desempenho dos Conferentes ── */}
        <section className="tv-metricas-section">
          <div className="tv-section-title">
            Desempenho do Dia
            {totalGeralConferencias > 0 && (
              <span style={{ marginLeft: '0.75rem', fontSize: '0.85rem', fontWeight: 400, color: '#94a3b8' }}>
                — {totalGeralConferencias} conferências no total
              </span>
            )}
          </div>
          <div className="tv-metricas-grid">
            {(metricas || []).map((conf, i) => {
              const uph = calcUPH(conf.total_conferencias, conf.tempo_trabalhado_minutos);

              const estaAtivo = (conferindoAgora || []).some(a => a.conferente === conf.conferente);
              const semPedidoInfo = (tempoSemPedido || []).find(t => t.conferente === conf.conferente);
              const minSemPedido  = parseInt(semPedidoInfo?.minutos_sem_pedido || 0);
              const participacao  = parseFloat(calcParticipacao(conf.total_conferencias, totalGeralConferencias));
              const corParticipacao =
                participacao >= 25 ? '#51cf66' :
                participacao >= 15 ? '#339af0' :
                participacao >= 8  ? '#ffa500' : '#94a3b8';

              const minAtivo = parseFloat(conf.tempo_trabalhado_minutos || 0);

              return (
                <div key={i} className={`tv-conf-card ${estaAtivo ? 'tv-conf-card--ativo' : ''}`}>
                  <div className={`tv-conf-dot ${estaAtivo ? 'tv-conf-dot--ativo' : 'tv-conf-dot--inativo'}`} />
                  <div className="tv-conf-nome">{conf.conferente?.split(' ')[0]}</div>
                  <div className="tv-conf-sobrenome">{conf.conferente?.split(' ').slice(1).join(' ')}</div>
                  <div className="tv-conf-total">
                    <span className="tv-conf-total-num" style={{ color: estaAtivo ? '#51cf66' : '#f1f5f9' }}>{conf.total_conferencias}</span>
                    <span className="tv-conf-total-label">conferências</span>
                  </div>

                  <div style={{ margin: '0.55rem 0 0.65rem', padding: '0 0.1rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '0.3rem' }}>
                      <span style={{ fontSize: '0.65rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 }}>Participação</span>
                      <span style={{ fontSize: '1.05rem', fontWeight: 700, color: corParticipacao }}>{participacao}%</span>
                    </div>
                    <div style={{ width: '100%', height: '6px', backgroundColor: '#1e293b', borderRadius: '99px', overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: `${participacao}%`, backgroundColor: corParticipacao, borderRadius: '99px', transition: 'width 0.6s ease', boxShadow: `0 0 6px ${corParticipacao}88` }} />
                    </div>
                    <div style={{ fontSize: '0.6rem', color: '#475569', marginTop: '0.2rem', textAlign: 'right' }}>
                      {conf.total_conferencias} de {totalGeralConferencias}
                    </div>
                  </div>

                  <div className="tv-conf-kpis">
                    <div className="tv-kpi">
                      <div className="tv-kpi-label">UPH</div>
                      <div className="tv-kpi-valor" style={{ color: uph ? '#339af0' : '#4b5563' }}>
                        {uph || '—'}
                      </div>
                      {uph && (
                        <div style={{ fontSize: '0.55rem', color: '#475569', marginTop: '1px' }}>
                          {formatarTempo(minAtivo)} ativo
                        </div>
                      )}
                    </div>
                    <div className="tv-kpi-divider" />
                    <div className="tv-kpi">
                      <div className="tv-kpi-label">Sem pedido</div>
                      <div className="tv-kpi-valor" style={{ color: estaAtivo ? '#51cf66' : getCorTempo(minSemPedido), fontSize: '1.1rem' }}>
                        {estaAtivo ? '● ativo' : formatarTempo(minSemPedido)}
                      </div>
                    </div>
                  </div>

                  {!estaAtivo && conf.tempo_presenca_minutos > 0 && (
                    <div className="tv-conf-barra-bg">
                      <div className="tv-conf-barra-fill" style={{
                        width: `${Math.min(100, (minSemPedido / conf.tempo_presenca_minutos) * 100)}%`,
                        backgroundColor: getCorTempo(minSemPedido),
                      }} />
                    </div>
                  )}
                </div>
              );
            })}
            {(metricas || []).length === 0 && (
              <div className="tv-vazio-metricas">Nenhum conferente registrado hoje</div>
            )}
          </div>
        </section>

        {/* ── Alertas de Inatividade ── */}
        {conferentesComAlerta.length > 0 && (
          <section className="tv-alertas-section">
            <div className="tv-section-title tv-section-title--alerta">⚠ Sem pedido há mais de 20 minutos</div>
            <div className="tv-alertas-grid">
              {conferentesComAlerta.map((c, i) => (
                <div key={i} className="tv-alerta-card">
                  <span className="tv-alerta-nome">{c.conferente}</span>
                  <span className="tv-alerta-tempo" style={{ color: getCorTempo(c.minutos_sem_pedido) }}>{formatarTempo(c.minutos_sem_pedido)}</span>
                  <span className="tv-alerta-sub">último às {formatarHora(c.ultimo_pedido)}</span>
                </div>
              ))}
            </div>
          </section>
        )}

      </div>
    </>
  );
};

export default TVLiberacaoComponent;